import React from 'react';

import { IIconProps, TIconType } from '../interface';

const CirclePolygonIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='24'
			width='24'
			{...props?.innerSvgProps}
		>
			<circle
				cx='12'
				cy='12'
				r='7.5'
				stroke='#2E2E6B'
			/>
			<path
				d='M12 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM12 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM19 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM5 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z'
				fill='currentColor'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default CirclePolygonIcon;
